import ApplicationController from '../application_controller'
import { v4 as uuidv4 } from 'uuid'

class DownloadFileController extends ApplicationController {
  static targets = ['submit']
  static values = { url: String }

  connect () {
    this.submitTarget.addEventListener('click', (event) => {
      event.preventDefault()
      this.download(this.urlValue)
    })
  }

  download (url) {
    const filename = uuidv4()

    fetch(url, { redirect: 'follow' })
      .then(response => response.blob())
      .then(blob => {
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = filename
        link.click()
      })
      .catch(console.error)
  }
}

export default DownloadFileController
